const single_sign_on = {
    forbidden_domains: 'Öffentliche E-Mail-Domänen sind nicht erlaubt.',
    duplicated_domains: 'Es gibt doppelte Domänen.',
    invalid_domain_format: 'Ungültiges Domänenformat.',
    duplicate_connector_name: 'Connector name already exists. Bitte wählen Sie einen anderen Namen.',
};
export default Object.freeze(single_sign_on);
